import React from 'react';
import { Bell, ShieldCheck } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext.js';

interface HeaderProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}

export const Header: React.FC<HeaderProps> = ({ title, subtitle, action }) => {
  const { user } = useAuth();

  return (
    <header className="h-20 bg-surface border-b border-bdr px-8 flex items-center justify-between sticky top-0 z-20">
      <div>
        <h1 className="text-xl font-bold text-txt-primary flex items-center gap-2">
          {title}
        </h1>
        {subtitle && (
          <p className="text-xs text-txt-secondary mt-0.5">{subtitle}</p>
        )}
      </div>

      <div className="flex items-center gap-4">
        {action}

        {/* Master Admin Indicator */}
        <div className="hidden md:flex items-center gap-1.5 px-3 py-1 bg-slate-100 text-brand-graphite border border-bdr rounded-full text-xs font-semibold">
          <ShieldCheck size={14} className="text-brand-primary" />
          <span>Controle Master</span>
        </div>

        {/* Notifications */}
        <button
          className="p-2 text-txt-secondary hover:text-txt-primary hover:bg-surface-secondary rounded-lg transition-colors relative"
          title="Notificações Globais"
        >
          <Bell size={18} />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-brand-primary rounded-full ring-2 ring-white"></span>
        </button>

        {/* User Avatar */}
        <div className="flex items-center gap-2.5 pl-2 border-l border-bdr">
          <div className="w-8 h-8 rounded-full bg-brand-graphite text-white flex items-center justify-center font-bold text-xs shadow-sm">
            {user?.fullName?.charAt(0) || 'M'}
          </div>
          <div className="hidden lg:block text-left leading-tight">
            <span className="block text-xs font-semibold text-txt-primary">
              {user?.fullName || 'Super Admin'}
            </span>
            <span className="block text-[10px] text-brand-primary font-medium">
              Acesso Global Master
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};
